<template>
  <div :class="$style.svgImageContainer" :style="{ 'max-width': width }">
    <component
      :is="require(`../../../assets${src}`).default"
      :class="$style.svgImageContainer__image"
    />
  </div>
</template>

<script>
export default {
  name: "vc-svg-img",
  props: {
    src: {
      type: String,
      default: ""
    },
    width: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" module>
.svgImageContainer {
  display: inline-block;
}
.svgImageContainer__image {
  width: 100%;
  height: auto;
}
</style>
